module.exports = __webpack_public_path__ + "static/media/Fire.e21140ae.svg";